export default __webpack_public_path__ + "static/media/screen.f7660f7b.png";